import React from "react";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import SVGList from "../../Misc/SvgIcons/SVGList";
import ReactToPrint from "react-to-print";
import TrackerSummaryPrint from "./TrackerSummaryPrint";

export default class TrackerSummaryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openedLines: [],
    };
  }
  toggleOpen = (idx) => {
    this.setState((state) => {
      let openedLines = state.openedLines;
      openedLines[idx] = openedLines[idx] ? false : true;
      return { openedLines };
    });
  };
  isOpen = (idx) => {
    const { openedLines } = this.state;
    return openedLines[idx] ? true : false;
  };

  renderPropValue = (prop = {}) => {
    if (prop.property) {
      if (prop.property.code === "cistern.property") {
        let json = JSON.parse(prop.value);
        if (Array.isArray(json)) {
          return (
            <table className="w-100">
              <tbody>
                {json.map((jsonItem) => {
                  let cistern = this.props.cistern[jsonItem.cistern] || {};
                  return (
                    <tr key={jsonItem.cistern}>
                      <td>{cistern.name}</td>
                      <td>{jsonItem.value}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          );
        }
      } else {
        return prop.value;
      }
    }
  };

  render() {
    const list = this.props.list || [];

    return (
      <>
        {list.map((line, idx) => {
          let item = line || {};
          let date = new Date(item.date) || {};
          let properties = item.properties || [];
          let cisterns = item.cisterns || [];
          let printRef = React.createRef();

          return (
            <div className="mb-4" key={item.id}>
              <div className="p-4 bg-lighter d-flex align-items-center justify-content-between">
                <div
                  className="cursor-pointer"
                  onClick={() => this.toggleOpen(idx)}
                >
                  {this.isOpen(idx) ? (
                    <i className="fa fa-angle-down mr-2"></i>
                  ) : (
                    <i className="fa fa-angle-right mr-2"></i>
                  )}
                  <span className="svg-icon mr-2 opacity-50">
                    <SVGList />
                  </span>
                  {date.toLocaleDateString()}
                  <span className="text-dark-50 ml-2">{item.ownername}</span>
                </div>
                <div>
                  <div className="d-flex align-items-center justify-content-end text-right">
                    {item.statecode !== "disabled" && (
                      <button
                        onClick={() => this.props.onEdit(item)}
                        className="btn btn-icon text-hover-dark"
                        title="Изменить"
                      >
                        <i className="fa fa-pencil"></i>
                      </button>
                    )}
                    <ReactToPrint
                      trigger={() => (
                        <button
                          className="btn btn-icon text-hover-dark"
                          title="Печать"
                        >
                          <i className="fa fa-print"></i>
                        </button>
                      )}
                      content={() => printRef.current}
                    />
                    <EssenceStateLabel
                      stateCode={item.statetypecode}
                      stateLabel={item.statelabel}
                      essence="summary"
                      id={item.id}
                    />
                    <EssenceActionsDropdown
                      essence={"summary"}
                      key={item.id}
                      id={item.id}
                      label={item.label}
                      onFinish={this.props.onFinish}
                    />
                  </div>
                </div>
              </div>
              <div style={{ display: "none" }}>
                <div className="to-print" ref={printRef}>
                  <TrackerSummaryPrint
                    item={item}
                    tracker={this.props.tracker}
                    cistern={this.props.cistern}
                  />
                </div>
              </div>
              {this.isOpen(idx) && (
                <div className="border p-4">
                  <TrackerSummaryPrint
                    item={item}
                    tracker={this.props.tracker}
                    cistern={this.props.cistern}
                  />
                </div>
              )}
            </div>
          );
        })}
      </>
    );
  }
}
